"use client";

import { usePrefersReducedMotion } from "@/lib/motion";
import { assetUrl } from "@/lib/asset-url";

export function HeroVideoBackground() {
  const reduced = usePrefersReducedMotion();

  return (
    <div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden">
      {/*
        poster: o navegador pinta esse frame estático quase instantaneamente,
        antes do vídeo em si sequer começar a carregar — sem isso, o LCP
        (maior elemento pintado) fica preso esperando o .mp4 inteiro, que em
        conexão móvel throttled pode levar vários segundos.
      */}
      {reduced ? (
        // eslint-disable-next-line @next/next/no-img-element
        <img
          src={assetUrl("/video/hero-bg-poster.jpg")}
          alt=""
          className="absolute inset-0 h-full w-full object-cover"
        />
      ) : (
        <video
          className="absolute inset-0 h-full w-full object-cover"
          poster={assetUrl("/video/hero-bg-poster.jpg")}
          preload="metadata"
          autoPlay
          loop
          muted
          playsInline
        >
          {/*
            No mobile o poster entrega a mesma composição sem transferir o
            MP4 de 1,5 MB. O atributo media no source impede que o navegador
            selecione (e baixe) o vídeo abaixo de 768 px.
          */}
          <source
            src={assetUrl("/video/hero-bg.mp4")}
            type="video/mp4"
            media="(min-width: 768px)"
          />
        </video>
      )}
      {/*
        Escurece o vídeo inteiro de forma uniforme (não só uma faixa no
        meio) — mantém o texto legível em qualquer altura da seção, sem
        criar um efeito de "vinheta" que ficava mais claro nas bordas.
      */}
      <div className="absolute inset-0 bg-[rgba(5,11,20,0.74)]" />
    </div>
  );
}
